import { render, staticRenderFns } from "./modalRepostaAgravo.vue?vue&type=template&id=947e7d1c"
import script from "./modalRepostaAgravo.vue?vue&type=script&lang=js"
export * from "./modalRepostaAgravo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports